import { VideoAskContext } from '../../lib/video-ask-client';

export const VideoAskProvider = ({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement => {
  return <VideoAskContext.Provider value={{}}>{children}</VideoAskContext.Provider>;
};
